<template>
	<div id="body">
		<div class="title">
			<i class="bi bi-key"></i> 设置密码
		</div>

		<el-form id="form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

			<div style="margin: 0 auto; margin-bottom: 20%; margin-top: -25%;">
				<img src="../../public/logo.png" style="margin-left: 20%; width: 70%; height: 70%;">
			</div>
			<el-form-item label="手机号码" prop="name">
				<el-input type="tel" v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="VCode" style="width: 225px;" id="yzm">
				<el-input v-model="ruleForm.VCode" type="tel" placeholder="请输入验证码"></el-input>
				<el-button type="primary" v-show="show" @click="getCode" class="yzm">获取验证码</el-button>
				<el-button type="primary" v-show="!show" class="count yzm">{{count}}s后重发</el-button>
			</el-form-item>
			<el-form-item label="密码" prop="pass">
				<el-input type="tel" style="-webkit-text-security: square" v-model.trim="ruleForm.pass"
					onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" minlength="6" maxlength="6"
					placeholder="请输入六位数字密码"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="checkPass">
				<el-input type="tel" style="-webkit-text-security: square" v-model.trim="ruleForm.checkPass"
					onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" minlength="6" maxlength="6"
					placeholder="请再次输入六位数字密码">
				</el-input>
			</el-form-item>

			<el-form-item style="margin-left: -80px;">
				<el-button type="primary" @click="submitForm('ruleForm')" class="register">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'register',
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {

				show: true,
				count: '',
				timer: null, //验证码

				ruleForm: {
					phone: '',
					VCode: '',
					pass: '',
					checkPass: ''
				},
				rules: {
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位的手机号码',
							trigger: 'blur'
						}
					],
					pass: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '请输入六位数字密码',
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '请输入六位数字密码',
						trigger: 'blur'
					}],
					VCode: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							min: 4,
							max: 4,
							message: '请输入4位的验证码',
							trigger: 'blur'
						}
					],
				}
			};
		},
		methods: {
			getCode() {
				if (this.ruleForm.phone != '') {
					this.$api({
						method: 'get',
						url: '/mobileLogin/sms?phone=' + this.ruleForm.phone
					}).then((res) => {
						console.log(res.data)
					});
					const TIME_COUNT = 60;
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.show = false;
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.show = true;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000)
					}
				} else {
					this.$notify.error({
						title: '请先填写手机号码',
						showClose: false,
						duration: 5000
					});
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api({
							methods: 'get',
							url: '/mobileLogin/changePassword?phone=' + this.ruleForm.phone + '&VCode=' +
								this.ruleForm.VCode + '&newPassword=' + this.ruleForm.checkPass,
						}).then((res) => {
							if (res.data.code == 200) {
								this.$router.push('/success?text=密码修改成功');
							}else if(res.data.code == 500){
                this.$router.push('/error?text=' + res.data.msg);
              } else {
								this.ruleForm.VCode = ''
								this.ruleForm.checkPass = ''
								this.$message.error(res.data.msg);
							}
						})
					} else {
						this.$notify.error({
							title: '请检查信息是否出错',
							showClose: false,
							duration: 5000
						});
						return false;
					}
				});
			},
		},
	}
</script>

<style scoped="scoped">
	input {
		-webkit-text-security: disc;
		text-security: disc;
		/*使用指定形状代替文字显示 circle圆圈 disc 圆形 square 正方形*/
	}

	.title {
		margin-bottom: 0.5rem;
	}

	.yzm {
		position: absolute;
		float: right;
		margin-left: 5px;
		width: 85%;
	}

	.demo-ruleForm {
		width: 95%;
		padding-right: 5%;
		margin: 0 auto;
	}

	.register {
		width: 100%;
		margin-bottom: 20px;
	}

	#form {
		padding-top: 40%;
		padding-bottom: 40%;
		background-color: #FFFFFF;
	}
</style>
